module.exports = __webpack_public_path__ + "img/slime.16136abd.png";